module.exports = __webpack_public_path__ + "static/media/ams-success-sky-blue.4f269ff4.gif";